/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsContactUsData } from './lds-contact-us.data';
import { ILdsContactUsProps } from './lds-contact-us.props.autogenerated';

export interface ILdsContactUsViewProps extends ILdsContactUsProps<ILdsContactUsData> {}

/**
 *
 * LdsContactUs Component
 * @extends {React.PureComponent<ILdsFooterProps<ILdsFooterData>>}
 */
class LdsContactUs extends React.PureComponent<ILdsContactUsProps<ILdsContactUsData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsContactUs;
